$(function () {

    // Define click event for to top button
    $("#scrollToTopButton").click(function () {
        $("html,body").animate({
            scrollTop: $("#site-header").offset().top
        }, "1000");
        return false;
    });

    // Show to top button only if page is scrolled at least 50px
    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $("#scrollToTopButton:hidden").stop(true, true).fadeIn();
        } else {
            $("#scrollToTopButton").stop(true, true).fadeOut();
        }
    });

});
